import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";
import { selectFeaturePermissions } from "store/global/authPermission/selector";
import { PermissionFeature } from "store/global/authPermission/types";
import BreadCrumb from "app/components/BreadCrumb";

import WorkOrderStatusSummary from "./components/WorkOrderStatusSummary";
import VehicleInYard from "./components/VehicleInYard";
import ScheduleExceptions from "./components/ScheduleExceptions";
import EngineeringAlerts from "./components/EngineeringAlerts";
import { reducer, sliceKey, actions } from "./redux/slice";
import { homeSaga } from "./redux/saga";
import { useStyles } from "./styles";

const Home = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useInjectSaga({
    key: sliceKey,
    saga: homeSaga,
  });

  useEffect(() => {
    dispatch(actions.getHomeData());
  }, [dispatch]);

  const featurePermissions = useSelector(selectFeaturePermissions);
  const { hasNoAccess } = featurePermissions[PermissionFeature.DASHBOARD];

  return (
    <Box className={classes.container}>
        {hasNoAccess ? (
          <Box className={classes.noPermissionRoot}>
            <Typography variant="h5">{t("COMMON.NO_PERMISSION")}</Typography>
          </Box>
        ) : (
          <Box className={classes.scrollContent}>
            <Box className={classes.pageContent}>
              <BreadCrumb title={t("SIDEBAR.HOME")} iconPosition="end" />

              <Box className={classes.pageBody}>
                <WorkOrderStatusSummary />

                <VehicleInYard />

                <Box className={classes.bottomGrid}>
                  <EngineeringAlerts />
                  <ScheduleExceptions />
                </Box>
              </Box>
            </Box>
          </Box>
        )}
    </Box>
  );
};

export default Home;